import {connect} from 'react-redux';
import { compose } from 'redux';
import { withCurrentUser } from './withUser';
import { InvitationsHeader } from '../components/invitations/InvitationsHeader';
import { filters } from '../reducers/invitations';
//import { fetchUserDomainInvitations } from '../actions/domains';

const mapStateToProps = ({invitationsById, pendingDomainInvitations}, {user}) => ({
  invitations: Object.keys(invitationsById)
    .map(k => invitationsById[k])
    .filter(filters.byEmail(user.email)),
  domainInvitations: pendingDomainInvitations,
})

const mapDispatchToProps = (dispatch, {fetchUserInvitations, fetchUserDomainInvitations}) => ({
  fetchInvitations: fetchUserInvitations,
  fetchDomainInvitations: fetchUserDomainInvitations,
});

export default compose(
  withCurrentUser,
  connect(mapStateToProps, mapDispatchToProps)
)(
  InvitationsHeader
)


// WEBPACK FOOTER //
// ./src/containers/UserInvitations.js